<template>
  <div>
    <BaseModal
      name="otherVehicleModalSingle"
      width="720"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="closeModalAndClearData"
      @before-open="loadData"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        v-if="stateLoading"
        class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
        style="top: 0; left: 0; z-index: 500"
      >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>

      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle tw-mx-auto"
        :style="{
          'min-height': `${minHeight}px`,
          width: isIntervalMode ? '720px' : '382px',
        }"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('otherVehicleModalSingle')"
        ></button>

        <div>
          <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
            {{ modalTitle }}
          </div>

          <div class="wp-100">
            <div class="d-flex gap-15">
              <div :class="isIntervalMode ? 'wp-50' : 'wp-100'">
                <div
                  class="wp-100 mb-10"
                  ref="vehicle_interval_events__id"
                  v-if="isIntervalMode"
                >
                  <span class="tw-app-input-container-label-type-2">
                    *Тип интервального события
                  </span>
                  <div class="multiselect-type-2">
                    <BaseSelect
                      style="width: 322px"
                      placeholder=""
                      selectLabel=""
                      deselectLabel=""
                      @input="onTypeSelectInput"
                      v-model="selectedTypeOption"
                      label="name"
                      :options="currentTypeOptions"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>

                <div
                  class="tw-mb-[6px]"
                  ref="vehicle_services__name"
                  v-if="isSingleMode"
                >
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    width="205"
                    input-name="vehicle_services__name"
                    @input="updateValue"
                    :value="dataForEmit.vehicle_services__name"
                    name-sign="*Название события"
                  >
                  </BaseInputNew>
                </div>
                <div class="tw-mb-[6px]" ref="vehicle_services__odometr">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    :width="'150'"
                    input-name="vehicle_services__odometr"
                    @input="updateValue"
                    :value="dataForEmit.vehicle_services__odometr"
                    name-sign="*Пробег прошедшего события"
                  >
                  </BaseInputNew>
                </div>
                <div class="tw-mb-[6px]" ref="vehicle_services__payed_to">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    :width="'322'"
                    class="flex-column align-items-start"
                    input-name="vehicle_services__payed_to"
                    @input="updateValue"
                    :value="dataForEmit.vehicle_services__payed_to"
                    name-sign="*Исполнитель (кому оплачено)"
                  >
                  </BaseInputNew>
                </div>
                <div class="tw-mb-[6px]" ref="vehicle_services__motohour">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    :width="'150'"
                    input-name="vehicle_services__motohour"
                    @input="updateValue"
                    :horizontalTitle="true"
                    :value="dataForEmit.vehicle_services__motohour"
                    name-sign="МЧ прошедшего события"
                  >
                  </BaseInputNew>
                </div>
                <div class="tw-mb-[6px]" ref="vehicle_services__price">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    :width="'150'"
                    input-name="vehicle_services__price"
                    @input="updateValue"
                    :value="dataForEmit.vehicle_services__price"
                    name-sign="Стоимость (спишется с ТФ)"
                  >
                  </BaseInputNew>
                </div>
              </div>
              <div class="wp-50" v-if="isIntervalMode">
                <div
                  style="border: 1px solid #0c63aa"
                  class="wp-100 tw-mb-[15px] tw-rounded-[5px]"
                >
                  <div
                    class="py-5 text-white fsc-14 text-center fw-semi-bold"
                    style="background-color: #0c63aa; line-height: 18px"
                  >
                    Запланировать повтор события через
                  </div>
                  <div class="py-30 px-20">
                    <div class="wp-100 tw-mb-[6px]" ref="interval_day">
                      <BaseInputNew
                        inputClass="tw-app-input-type-2"
                        :width="'138'"
                        input-name="interval_day"
                        @input="updateValue"
                        :horizontalTitle="true"
                        :value="dataForEmit.interval_day"
                        name-sign="Дней"
                      >
                      </BaseInputNew>
                    </div>
                    <div class="wp-100 tw-mb-[6px]" ref="interval_km">
                      <BaseInputNew
                        inputClass="tw-app-input-type-2"
                        placeholder=""
                        :width="'138'"
                        input-name="interval_km"
                        @input="updateValue"
                        :horizontalTitle="true"
                        :value="dataForEmit.interval_km"
                        name-sign="Километров"
                      >
                      </BaseInputNew>
                    </div>
                    <div class="wp-100 tw-mb-[6px]" ref="interval_motohour">
                      <BaseInputNew
                        inputClass="tw-app-input-type-2"
                        placeholder=""
                        :width="'138'"
                        input-name="interval_motohour"
                        @input="updateValue"
                        :horizontalTitle="true"
                        :value="dataForEmit.interval_motohour"
                        name-sign="Моточасов"
                      >
                      </BaseInputNew>
                    </div>
                  </div>
                  <div
                    class="py-5 fsc-14 text-center text-white"
                    style="background-color: #0c63aa; line-height: 18px"
                  >
                    Можно заполнить все/несколько/один <br />
                    интервал. Если не заполнить ничего - <br />
                    событие не будет поставлено в план
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex gap-15"
              :class="{
                'flex-column': !isIntervalMode,
                'mt-20': !isIntervalMode,
              }"
            >
              <div class="wp-50" :class="{ 'wp-100': !isIntervalMode }">
                <div class="wp-100" ref="vehicle_services__text">
                  <BaseTextarea
                    style="height: 120px"
                    signClass="tw-text-[11px]"
                    input-name="vehicle_services__text"
                    @onInput="updateValue"
                    :value="dataForEmit.vehicle_services__text"
                    inputClass="tw-text-[11px] tw-app-input-type-2 tw-h-full"
                    name-sign="Комментарий (по желанию)"
                  >
                  </BaseTextarea>
                </div>
              </div>
              <div class="wp-50" :class="{ 'wp-100': !isIntervalMode }">
                <div
                  class="tw-text-center tw-bg-[#F5F5F5] tw-py-[10px] tw-px-[15px] tw-text-forTitle tw-text-[14px] tw-font-bold tw-mb-[10px] tw-rounded-[3px]"
                >
                  {{ dataLang["vehicle_modal_service_modals_warning1"] }}
                </div>

                <div
                  class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center"
                >
                  <button
                    @click="$modal.hide('otherVehicleModalSingle')"
                    class="tw-app-btn-muted tw-app-btn-muted-lg"
                  >
                    {{ dataLang["vehile_modal_btn_reset"] }}
                  </button>
                  <button
                    @click="sendData(false)"
                    class="tw-app-btn-primary tw-app-btn-primary-lg"
                    :disabled="submitting"
                  >
                    {{ dataLang["vehile_modal_btn_save"] }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="acceptUpdateMilageNew"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="closeModalAndClearData"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        v-if="stateLoading"
        class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
        style="top: 0; left: 0; z-index: 500"
      >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('acceptUpdateMilageNew')"
        ></button>

        <div class="tw-text-center">
          <div
            v-html="errorMessage"
            class="tw-text-[14px] tw-text-danger tw-my-[30px]"
          ></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptUpdateMilageNew')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="sendData(true)"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/event-bus.js";
import GeneralService from "@/api/GeneralService";

export default {
  props: {
    nameForAction: {
      type: String,
    },
    modalName: {},
    centered: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    size: {
      type: String,
      default: "",
    },
    minHeight: {
      type: Number,
    },
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      submitting: false,
      intervalsData: [],
      modalServiceType: 3,
      errorMessage: "",
      selectedTypeOption: null,
      intervalEventOptions: [],
      dataForEmit: {
        vehicle_services__service_type_id: 9,
        vehicle_services__name: null,
        vehicle_interval_events__id: null,
        vehicle_services__odometr: null,
        vehicle_services__payed_to: null,
        vehicle_services__motohour: null,
        vehicle_services__price: null,
        vehicle_services__text: null,
        interval_day: null,
        interval_km: null,
        interval_motohour: null,
      },
    };
  },
  methods: {
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },

    loadData(event) {
      this.closeModalAndClearData();
      this.errorMessage = "";
      const incomingType = Number(event?.params?.type);
      this.modalServiceType = incomingType === 9 ? 9 : 3;
      this.dataForEmit.vehicle_services__service_type_id =
        this.modalServiceType;
      if (this.isIntervalMode) {
        this.loadIntervalEventOptions();
      }
    },

    onTypeSelectInput(option) {
      this.selectedTypeOption = option || null;
      this.updateValue({
        name: "vehicle_interval_events__id",
        value: option?.id || null,
      });
      if (option?.id) {
        let data = this.intervalsData.find(
          (i) => i.vehicle_interval_events__id === option.id
        );
        this.dataForEmit.interval_day =
          data?.vehicle_interval_events__day ?? null;
        this.dataForEmit.interval_km =
          data?.vehicle_interval_events__km ?? null;
        this.dataForEmit.interval_motohour =
          data?.vehicle_interval_events__motohour ?? null;
      }
    },

    loadIntervalEventOptions() {
      const vehicleId = this.optionalParams?.id;
      this.intervalEventOptions = [];

      if (!vehicleId) {
        return;
      }

      GeneralService.get(`/object_interval_events/${vehicleId}`)
        .then((response) => {
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          const rows = response?.data?.data?.rows || [];
          this.intervalsData = response?.data?.data?.rows || [];
          this.intervalEventOptions = rows.map((item) => ({
            id: item.vehicle_interval_events__id,
            name: item.vehicle_interval_events__name,
          }));
        })
        .catch(() => {
          this.intervalEventOptions = [];
        });
    },

    buildPayload(isConfirm) {
      const payload = {
        vehicle_services__service_type_id: this.modalServiceType,
        vehicle_services__odometr: this.dataForEmit.vehicle_services__odometr,
        vehicle_services__payed_to: this.dataForEmit.vehicle_services__payed_to,
        vehicle_services__motohour: this.dataForEmit.vehicle_services__motohour,
        vehicle_services__price: this.dataForEmit.vehicle_services__price,
        vehicle_services__text: this.dataForEmit.vehicle_services__text,
        ...(isConfirm && { confirmed: true }),
      };

      if (this.isIntervalMode) {
        payload.vehicle_interval_events__id =
          this.dataForEmit.vehicle_interval_events__id;
        payload.interval_day = this.dataForEmit.interval_day;
        payload.interval_km = this.dataForEmit.interval_km;
        payload.interval_motohour = this.dataForEmit.interval_motohour;
      }

      if (this.isSingleMode) {
        payload.vehicle_services__name =
          this.dataForEmit.vehicle_services__name;
      }

      return payload;
    },

    sendData(isConfirm) {
      this.submitting = true;
      GeneralService.editOrCreate(
        `/objects/${this.optionalParams.id}/services`,
        this.buildPayload(isConfirm)
      )
        .then(() => {
          this.closeModalAndClearData();
          this.submitting = false;
          this.$toast.success("Запись добавлена");

          Object.keys(this.dataForEmit).forEach((elem) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });

          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          this.$modal.hide("otherVehicleModalSingle");
          this.$modal.hide("acceptUpdateMilageNew");
        })
        .catch((err) => {
          this.submitting = false;
          const responseData = err?.response?.data || {};

          if (responseData.errorCode === 11) {
            this.$modal.show("acceptUpdateMilageNew");
            this.errorMessage = responseData.message;
          } else {
            this.$toast.error(responseData.message || "Ошибка при сохранении", {
              duration: 5000,
            });
          }

          if (responseData.errors && typeof responseData.errors === "object") {
            Object.keys(responseData.errors).forEach((elem) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add("input-error");
              }
            });
          }
        });
    },

    closeModalAndClearData() {
      for (const key in this.dataForEmit) {
        this.dataForEmit[key] = null;
      }
      this.selectedTypeOption = null;
      this.dataForEmit.vehicle_services__service_type_id =
        this.modalServiceType;
    },
  },

  computed: {
    ...mapState("modalStackModule", ["modalStackPosition"]),
    ...mapState("translationModule", ["dataLang"]),
    isIntervalMode() {
      return this.modalServiceType === 9;
    },
    isSingleMode() {
      return this.modalServiceType === 3;
    },
    modalTitle() {
      return this.isSingleMode
        ? "Добавить разовое событие"
        : "Добавить интервальное событие";
    },
    typeSelectLabel() {
      return this.isSingleMode
        ? "*Тип разового события"
        : "*Тип интервального события";
    },
    currentTypeOptions() {
      return this.intervalEventOptions;
    },
  },
};
</script>
